import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, ComplainAttachment } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, MasterConstants, JobOperationActions } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';
import { AppSettings } from '../../Library/AppSettings';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MessagingService } from '../../Services/MessagingService';


@Component({
    selector: 'MessageDetail',
    templateUrl: './MessageDetail.html'
})

export class MessageDetail extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    ModalRef: NgbModalRef;
    Model: any;

    DateFormat: string;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, private modalService: NgbModal, private _messagingService: MessagingService) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {
        this.DateFormat = this.masterService.GetPropertyDateFormat(null);
    }


    Open(Data: any): void {
        this.Model = _.cloneDeep(Data);
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg', 
            centered: true
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
    }
}
